<template>
  <div class="star-right">
    <Switch-tab v-if="switchList && switchList.length" :activeIs="activeIs"
                :switchList="switchList" @headlerClick="headlerClick"></Switch-tab>
    <article-list v-if="showInfo" :key="$route.fullPath" :articleLists="articleListFilter" :childName="this.childName"
                  :class="switchList && switchList.length?'marginTop':''"
                  :parentName="parentName"
                  getContainer=".article-list"></article-list>
    <div v-if="!showInfo && !loadShow" class="article-emply">
      <img alt="" src="@/assets/images/powderedMilk/fhblank.png">
      <p>sorry亲，没找到您搜索的内容，还有很多奶粉知识，您可以再看哟～</p>
    </div>
    <div style="text-align: center">
      <van-loading v-if="loadShow" size="24px">加载中...</van-loading>
    </div>
    <div v-if="articleInfoLists.length>=5 && this.stairLabelInfo" class="right-more" @click="headlerRouter">
      查看更多 <img alt="" src="@/assets/images/powderedMilk/catMore.png">
    </div>
  </div>
</template>
<script>
import SwitchTab from './switchTab.vue'
import articleList from './articleList.vue';
// import minxins from '@/minxs/milkPowderStar.js'
import {BuiedPointClick_Fn} from '@/assets/js/BuriedPointEvent'

export default {
  name: 'starRight',
  // mixins: [minxins],
  data() {
    return {
      childName: '',
      activeIs: this.activeISKey,
      showInfo: true,
      secondLabel: 0
    }
  },
  props: {
    switchList: {
      type: Array,
      required: true
    },
    stairLabelInfo: Number,
    articleInfoLists: Array,
    parentName: String,
    isShowInit: Boolean,
    loadShow: Boolean,
    activeISKey: Number
  },
  watch: {
    switchList: {
      handler(newValue) {
        this.switchList = newValue;
        if (newValue.length) {
          this.secondLabel = newValue[0].childId
          this.activeIs = newValue[0].childId
          this.childName = newValue[0].childName
        } else {
          this.activeIs = 0
        }
      },
      // immediate: true
    },
    stairLabelInfo: {
      handler(newValue) {
        console.log(newValue, 'stairLabelInfo')
        this.stairLabel = newValue
        // this.activeIs = this.switchList[0].childId
      }
    },
    isShowInit: {
      handler(newValue) {
        this.showInfo = newValue
      }
    },
  },
  computed: {
    articleListFilter: function () {
      return this.articleInfoLists.filter((item, index) => index < 5)
    },

  },
  created() {
  },
  methods: {
    // 点击二级菜单
    headlerClick(item) {
      this.articleLists = []
      this.stairLabel = this.stairLabelInfo
      this.secondLabel = item.childId
      this.activeIs = this.secondLabel
      this.childName = item.childName
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      console.log(babyBuried,'babyBuried');
      BuiedPointClick_Fn('milkinfo_home_star_secondclassify_click', {
        Baby_Month: babyBuried ? babyBuried.name : "",
        secondclassify_name: item.childName
      })
      this.$parent.getMilkInfoList({stairLabel: this.stairLabelInfo, secondLabel: item.childId})

    },
    headlerRouter() {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      BuiedPointClick_Fn('milkinfo_home_star_more_click', {
        Baby_Month: babyBuried ? babyBuried.name : "",
        firstclassify_name: this.parentName
      })
      this.$router.push({
        name: 'milkArticleLists',
        query: {
          // 头部title，
          previousTitle: this.parentName,
          // 区分奶粉星球和专题
          previousStatus: 'milk',
          // 第一级标签
          parentId: this.stairLabel,
          // 第二级标签  没有就不传
          planetTag: this.secondLabel
        }
      })
    }
  },
  components: {
    SwitchTab,
    articleList
  }
}
</script>
<style lang="less" scoped>
@topTranslate: calc(50% - 90px);
.star-right {
  flex: 1;
  flex-basis: auto;
  flex-shrink: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  .right-more {
    display: flex;
    font-size: 14px;
    color: #F470BE;
    font-weight: 400;
    line-height: 20px;
    padding-left: 68px;
    margin-top: 12px;
    padding-bottom: 16px;

    img {
      width: 12px;
      height: 12px;
      margin-top: 3px;
      margin-left: 2px;
    }

    //text-align: center;
  }

  .marginTop {
    margin-top: 16px !important;
  }

  .article-list {
    width: 253px;
    margin: 0 auto;
  }

  .tblx {
    margin-top: 12px;
    width: 273px;
  }

  .article-emply {
    text-align: center;
    position: absolute;
    top: @topTranslate;
    left: 50%;
    transform: translate(-50%);

    img {
      width: 86px;
      height: 72px;
    }

    p {
      width: 210px;
      height: 30px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
      margin: 0 auto;
      margin-top: 14px;
    }
  }
}

</style>
